import React from 'react';
import ReactHelmet from '../ReactHelmet/ReactHelmet';
import BlogList from '../blogs/BlogList';
import CommentSection from '../CommentSection/CommentSection';

const Blogs = () => {


  return (
    <div>
        <ReactHelmet title="Blogs" />
      <div className="title-section text-center">
        <h1 className="text-primary">
          Upcoming Blogs &<span className="text-amber-500"> Insights</span>
        </h1>
        <span className="title-bg text-primary">blogs</span>
      </div>
      <BlogList />

      {/* Use the CommentSection component */}



      <CommentSection />
    </div>
  );
};

export default Blogs;
